import PlayIcon from "@mui/icons-material/PlayArrow";
import { Button, IconButton, Tooltip } from "@mui/material";
import React from "react";

interface AutoParkButtonProps {
  onClick: () => void;
  disabled: boolean;
  disabledMessage?: string;
  compact?: boolean;
  inGroup?: boolean;
  fullWidth?: boolean;
}

export const AutoParkButton: React.FC<AutoParkButtonProps> = ({
  onClick,
  disabled,
  disabledMessage = "AutoParking is not enabled for this ramp. Enable it in the ramp settings.",
  compact = false,
  inGroup = false,
  fullWidth = false,
}) => {
  const button = compact ? (
    <IconButton
      color="primary"
      onClick={onClick}
      disabled={disabled}
      size="small"
      sx={{
        bgcolor: disabled ? undefined : "primary.main",
        color: disabled ? undefined : "white",
        "&:hover": {
          bgcolor: disabled ? undefined : "primary.dark",
        },
      }}
    >
      <PlayIcon />
    </IconButton>
  ) : (
    <Button
      variant="contained"
      color="primary"
      onClick={onClick}
      startIcon={<PlayIcon />}
      fullWidth={fullWidth}
      disabled={disabled}
      size="small"
    >
      AutoPark
    </Button>
  );

  const tooltipTitle = compact ? "AutoPark" : disabled ? disabledMessage : "";

  if (disabled || compact) {
    return (
      <Tooltip title={tooltipTitle || disabledMessage}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
};
